import React from "react";
import { FilterDropdown, FilterConfig, FilterOption } from "@/components/ui/filter-dropdown";

interface FilterTravelRequestButtonProps {
  filters: FilterConfig[];
  onFiltersChange: (filters: FilterConfig[]) => void;
  options: FilterOption[];
  disabled?: boolean;
}

/**
 * Filtri della toolbar richieste. Li applica la RPC get_dashboard_travel_requests_page:
 * la lista e' paginata, il browser non ha tutte le righe da filtrare.
 */
export const FilterTravelRequestButton: React.FC<FilterTravelRequestButtonProps> = ({
  filters,
  onFiltersChange,
  options,
  disabled = false,
}) => (
  <FilterDropdown
    filters={filters}
    onFiltersChange={onFiltersChange}
    options={options}
    disabled={disabled}
  />
);
